import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.png';

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <nav className="bg-gray-900 shadow-sm sticky top-0 z-50 border-b border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo/Name */}
          <div className="flex items-center">
            <Link to="/" onClick={handleScrollToTop} className="flex items-center">
              <img
                src={logo}
                alt="JasonSchmitt.dev"
                className="h-14 w-14"
                style={{
                  filter: 'brightness(0) saturate(100%) invert(70%) sepia(98%) saturate(555%) hue-rotate(141deg) brightness(97%) contrast(92%)',
                }}
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center md:space-x-8">
            <Link
              to="/#about"
              className="text-white hover:text-cyan-400 px-3 py-2 text-sm font-medium transition-colors"
            >
              About
            </Link>
            <Link
              to="/experience"
              onClick={handleScrollToTop}
              className="text-white hover:text-cyan-400 px-3 py-2 text-sm font-medium transition-colors"
            >
              Experience
            </Link>
            <Link
              to="/blog"
              onClick={handleScrollToTop}
              className="text-white hover:text-cyan-400 px-3 py-2 text-sm font-medium transition-colors"
            >
              Blog
            </Link>
            <Link
              to="/#contact"
              className="text-white hover:text-cyan-400 px-3 py-2 text-sm font-medium transition-colors"
            >
              Contact
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden">
            <button
              type="button"
              aria-label="Toggle menu"
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-cyan-400 hover:bg-gray-800 focus:outline-none"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? (
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <Link
                to="/#about"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block w-full text-left text-white hover:bg-gray-800 hover:text-cyan-400 px-3 py-2 rounded-md text-base font-medium"
              >
                About
              </Link>
              <Link
                to="/experience"
                onClick={() => {
                  setIsMobileMenuOpen(false);
                  handleScrollToTop();
                }}
                className="block w-full text-left text-white hover:bg-gray-800 hover:text-cyan-400 px-3 py-2 rounded-md text-base font-medium"
              >
                Experience
              </Link>
              <Link
                to="/blog"
                onClick={() => {
                  setIsMobileMenuOpen(false);
                  handleScrollToTop();
                }}
                className="block w-full text-left text-white hover:bg-gray-800 hover:text-cyan-400 px-3 py-2 rounded-md text-base font-medium"
              >
                Blog
              </Link>
              <Link
                to="/#contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block w-full text-left text-white hover:bg-gray-800 hover:text-cyan-400 px-3 py-2 rounded-md text-base font-medium"
              >
                Contact
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
